import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/precisionpart-frontend/precisionpart-frontend/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/precisionpart-frontend/precisionpart-frontend/src/components/blocks/ParallaxHero.tsx");
